// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qr-2";
export var chatLink = "_qr-0";
export var chatText = "_qr-1";